import { createSlice } from '@reduxjs/toolkit';

const LoginSlice = createSlice({
  name: 'login',
  initialState: {
    role: 0
  },
  reducers: {
    SetRole: (state, action) => {
      state.role = action.payload;
    }
  }
});

export const { SetRole } = LoginSlice.actions;
export default LoginSlice.reducer;
